import React from "react";
import "./Settings.css";
const SettingLayout = ({ title, children }) => {
  return (
    <div className="font-secondary">
      <div className="fw-bold mb-2">{title}</div>
      <div className="box-setting">{children}</div>
    </div>
  );
};

export default SettingLayout;
